<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <div class="overlay">
        
        <!-- BLOQUE DE NOMBRES SUPERIOR (Estilo idéntico a la referencia) -->
        <div ref="nombreContainerRef" class="header-nombres">
          <div ref="nombrePrincipalRef" class="nombre-principal">
             Angie  <br> Izabella 
          </div>
          <div ref="apellidoRef" class="apellido-texto">
          </div>
        </div>

        <!-- CORONA Y MIS XV DEBAJO DE LOS NOMBRES -->
        <div ref="misXvContainerRef" class="mis-xv-wrapper">
         
          <div
            ref="misXvTopRef"
            class="mis-xv-top"
          >
            MIS XV
          </div>
        </div>

        <!-- FECHA EN LA PARTE INFERIOR -->
        <div
          ref="fechaRef"
          class="fecha-evento"
        >
          <span class="fecha-dia"></span>
          <span class="fecha-separador"></span>
          <span class="fecha-mes"></span>
          <span class="fecha-separador"></span>
          <span class="fecha-anio"></span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null)
    const nombrePrincipalRef = ref(null)
    const apellidoRef = ref(null)
    const misXvTopRef = ref(null)
    const coronaRef = ref(null)
    const fechaRef = ref(null)

    onMounted(() => {
      // 1. Aparición suave del fondo general
      gsap.from(fotoPortadaRef.value, {
        opacity: 0,
        duration: 1.2,
        ease: 'power2.out'
      })

      // Línea de tiempo principal para orquestar las animaciones independientes
      const tl = gsap.timeline({ delay: 0.4 })

      // 2. Nombre principal ("ISABELA") baja con elegancia y zoom sutil desde arriba
      tl.fromTo(
        nombrePrincipalRef.value,
        {
          opacity: 0,
          y: -40,
          scale: 0.92,
          filter: 'blur(8px)'
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          filter: 'blur(0px)',
          duration: 1.3,
          ease: 'power3.out'
        }
      )

      // 3. Apellido ("RAMIREZ") aparece desvaneciéndose con un pequeño desplazamiento lateral
      tl.fromTo(
        apellidoRef.value,
        {
          opacity: 0,
          y: 20,
          letterSpacing: '0.4em',
          filter: 'blur(4px)'
        },
        {
          opacity: 1,
          y: 0,
          letterSpacing: '0.25em',
          filter: 'blur(0px)',
          duration: 1.1,
          ease: 'power3.out'
        },
        '-=0.8'
      )

      // 4. Corona aparece con efecto de zoom y rotación delicada
      tl.fromTo(
        coronaRef.value,
        {
          opacity: 0,
          scale: 0.5,
          rotation: -10
        },
        {
          opacity: 1,
          scale: 1,
          rotation: 0,
          duration: 1.0,
          ease: 'back.out(1.7)'
        },
        '-=0.6'
      )

      // 5. Texto "MIS XV" sube suavemente debajo de la corona
      tl.fromTo(
        misXvTopRef.value,
        {
          opacity: 0,
          y: 25
        },
        {
          opacity: 1,
          y: 0,
          duration: 1.0,
          ease: 'power3.out'
        },
        '-=0.7'
      )

      // 6. Fecha inferior con animación escalonada (stagger)
      if (fechaRef.value) {
        tl.fromTo(
          fechaRef.value.children,
          {
            opacity: 0,
            y: 20
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1,
            ease: 'power2.out'
          },
          '-=0.5'
        )
      }

      // 7. Movimiento continuo de flotación suave para la corona
      gsap.to(coronaRef.value, {
        y: '-=6',
        duration: 3,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        delay: 2.5
      })
    })

    return {
      fotoPortadaRef,
      nombrePrincipalRef,
      apellidoRef,
      misXvTopRef,
      coronaRef,
      fechaRef
    }
  }
}
</script>

<style scoped>
.fotoportada-container {
  position: relative;
  width: 100%;
  height: 105vh;
  overflow: hidden;
  margin-top: 0px;
  background-image: 
    linear-gradient(to bottom, rgba(255,255,255,0), rgba(0, 0, 0, 0.2)), 
    url('@/assets/A7402940_11zon.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 1;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 8vh;
  color: white;
  z-index: 2;
  background: linear-gradient(
    to bottom,
    rgba(0,0,0,0.08),
    rgba(0, 0, 0, 0.22)
  );
}

/* ESTILO IDÉNTICO AL DE LA REFERENCIA PARA LOS NOMBRES */
.header-nombres {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3vh;
}

.nombre-principal {
  font-family: 'cursivatitulo', serif;
  font-size: clamp(3rem, 9vw, 5rem);
  line-height: 1;
  letter-spacing: 0.04em;
  background: white;
  -webkit-background-clip: text;
  color: transparent;
  will-change: transform, opacity;
}

.apellido-texto {
  font-family: 'british', cursive;
  font-size: clamp(1rem, 3.5vw, 1.4rem);
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: #ffffff;
  margin-top: 0.6vh;
  will-change: transform, opacity;
}

/* CORONA Y MIS XV */
.mis-xv-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: auto;
  will-change: transform, opacity;
}

.ornamento-img {
  width: 38px;
  filter: brightness(0) invert(1);
  margin-bottom: 6px;
  will-change: transform, opacity;
}

.mis-xv-top {
  font-family: 'file', sans-serif;
  font-size: clamp(1.3rem, 4.5vw, 1.8rem);
  letter-spacing: 2px;
  color: white;
  will-change: transform, opacity;
}

/* FECHA INFERIOR */
.fecha-evento {
  color: white;
  font-size: clamp(0.95rem, 3vw, 1.2rem);
  display: flex;
  gap: 12px;
  justify-content: center;
  letter-spacing: 0.2em;
  padding-bottom: 7vh;
}

.fecha-evento span {
  will-change: transform, opacity;
}
</style>